import styled from 'styled-components'

export const ItemsContainer = styled.div`
  position: relative;
  overflow-y: scroll;
  max-height: calc(100vh - 334px);
  margin-bottom: 10px;
  padding-bottom: 80px;
`
